import React, { useCallback } from 'react'

import { BulletinAttachment } from '../../../../../../../common/validations'

import { useOpenFile } from 'hooks/useOpenFile/useOpenFile'
import { useAPIGetBulletinAttachment } from 'api/apiHooks/useAPIGetBulletinAttachment'
import { FileLink } from 'components/FileLink/FileLink'

interface AttachmentLinkProps {
  attachment: BulletinAttachment
}

export const AttachmentLink: React.FC<AttachmentLinkProps> = ({
  attachment,
}) => {
  const { refetch: refetchSignedUrl } = useAPIGetBulletinAttachment(
    attachment.uuid
  )

  const getSignedUrl = useCallback(async () => {
    const { data } = await refetchSignedUrl()

    return data?.url
  }, [refetchSignedUrl])

  const { openFile } = useOpenFile(getSignedUrl)

  return <FileLink name={attachment.name} onClick={openFile} />
}
